var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat-auth-container"},[_c('div',{staticClass:"loading-wrapper"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa","size":"24px"}}),_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.loadingText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }